import React, { useContext } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import Clickable from 'components/Common/Clickable'
import Image from 'components/Common/Image'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import GeoContext from 'contexts/geoContext'
import { campaignRegionImages } from 'components/utils/tour-luxplus-campaign-regions'

const BannerImage = styled(Image)`
  padding-top: ${rem(5)};
  padding-bottom: ${rem(20)};
  width: 100%;
`

function TourLuxPlusDiscountBanner() {
  const intl = useIntl()
  const { currentRegionCode } = useContext(GeoContext)

  const images = campaignRegionImages[currentRegionCode as keyof typeof campaignRegionImages]

  if (!images) {
    return null
  }

  const altText = intl.formatMessage(
    {
      id: 'I/9X/MAvuM',
      defaultMessage: 'Unlock an extra 5% off tours with LuxPlus+',
      description: 'Alt text for LuxPlus+ discount banner image on tours page',
    },
  )

  return <Clickable to="/search/tours?destinationId=le_d41d8cd98f00b204e9800998ecf8427e&destinationName=Anywhere&categories=luxexclusive">
    <CSSBreakpoint min="tablet">
      <BannerImage image={{ id: images.desktop }} alt={altText} />
    </CSSBreakpoint>
    <CSSBreakpoint max="mobile">
      <BannerImage image={{ id: images.mobile }} alt={altText} />
    </CSSBreakpoint>
  </Clickable>
}

export default TourLuxPlusDiscountBanner
